<template>
    <div>
        <!-- Campo de texto para la fecha -->
        <v-text-field
            :label="label"
            :readonly="readonly"
            :dense="dense"
            v-model="modelData"
            rounded
            filled
            :rules='[
                value => value?/^([0-2][0-9]|3[0-1])(\/)(0[1-9]|1[0-2])\2(\d{4})$/.test(value)||"Formato debe ser tipo 31/01/2021":true,
                ...rules
            ]'
            append-icon="mdi-calendar"
            @click:append="abreDatePickerMenu"
        />
        <!-- Diálogo para el selector de fecha -->
        <v-dialog
            ref="dialog"
            v-model="modal"
            :return-value.sync="date"
            persistent
            width="290px"
        >
            <!-- Selector de fecha -->
            <v-date-picker
                v-model="date"
                scrollable
                :max="futuro ? null : moment().format('YYYY-MM-DD')"
            >
                <!-- Botón para establecer la fecha de hoy -->
                <v-btn
                    small
                    color="primary"
                    @click="setHoy"
                >
                    Hoy
                </v-btn>
                <v-spacer></v-spacer>
                <!-- Botón para cancelar y cerrar el selector -->
                <v-btn
                    small
                    icon
                    color="error"
                    @click="modal = false"
                >
                    <v-icon>mdi-cancel</v-icon>
                </v-btn>
                <v-btn
                    small
                    color="success"
                    @click="guardaFecha(date)"
                >
                    <v-icon>mdi-check-bold</v-icon>
                </v-btn>
            </v-date-picker>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: {
        /**
         * Etiqueta para el campo de texto.
         * @type {String}
         */
        label: String,
        /**
         * Modelo de datos para el campo de texto.
         * @type {String}
         */
        model: String,
        /**
         * Indica si el campo de texto es de solo lectura.
         * @type {Boolean}
         */
        readonly: Boolean,
        /**
         * Indica si el campo de texto debe ser denso.
         * @type {Boolean}
         */
        dense: Boolean,
        /**
         * Reglas de validación para el campo de texto.
         * @type {Array}
         */
        rules: Array,
        /**
         * Indica si se permite seleccionar fechas futuras.
         * @type {Boolean}
         */
        futuro: Boolean,
    },
    data() {
        return {
            /**
             * Estado del diálogo del selector de fecha.
             * @type {Boolean}
             */
            modal: false,
            /**
             * Fecha seleccionada.
             * @type {String}
             */
            date: '',
        };
    },
    methods: {
        /**
         * Abre el menú del selector de fecha. Si no hay una fecha seleccionada, establece la fecha actual.
         */
        abreDatePickerMenu() {
            if (!this.modelData) {
                this.setHoy();
            } else {
                this.date = this.moment(this.model, "DD/MM/YYYY").format("YYYY-MM-DD");
            }
            this.modal = true;
        },
        /**
         * Guarda la fecha seleccionada en el formato 'DD/MM/YYYY' y emite el evento 'fechaActualizada'.
         * @param {String} v - La fecha seleccionada.
         */
        guardaFecha(v) {
            this.modelData = this.moment(v).format('DD/MM/YYYY');
            this.$emit('fechaActualizada');
            this.modal = false;
        },
        /**
         * Establece la fecha actual en el formato 'YYYY-MM-DD'.
         */
        setHoy() {
            this.date = this.moment(new Date()).format('YYYY-MM-DD');
        },
    },
    computed: {
        /**
         * Propiedad computada para obtener y establecer el valor del modelo.
         */
        modelData: {
            get() {
                return this.model;
            },
            set(v) {
                this.$emit('update:model', v);
            },
        },
    },
    watch: {
        /**
         * Observa cambios en la propiedad 'requerido' y establece las reglas de validación.
         * @param {Boolean} v - El nuevo valor de la propiedad 'requerido'.
         */
        requerido(v) {
            if (v) {
                this.rules = [value => !!value || 'Requerido.'];
            }
        },
    },
};
</script>

<style>
</style>